import { render, staticRenderFns } from "./ProductCombinationPricesForm.vue?vue&type=template&id=a3745b48&scoped=true&"
import script from "./ProductCombinationPricesForm.vue?vue&type=script&lang=js&"
export * from "./ProductCombinationPricesForm.vue?vue&type=script&lang=js&"
import style0 from "./ProductCombinationPricesForm.vue?vue&type=style&index=0&id=a3745b48&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a3745b48",
  null
  
)

export default component.exports